import { render, staticRenderFns } from "./SitesNavigation.vue?vue&type=template&id=8f79a774&"
import script from "./SitesNavigation.vue?vue&type=script&lang=js&"
export * from "./SitesNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SitesNavigation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports